import React from 'react'
import {Bannerdata,LatestUpdate,VastuTips,DIY} from "./data"
import Banner_News_Updates from '../components/body/topnewsupdates/Banner-News-Updates'
import Navbar from '../components/Navbar/Navbar'
import Main_Footer from '../components/footer/IndiaFooter/Main_Footer'
import Slider_Card from '../components/body/topnewsupdates/Slider-Card'

const NewsUpdates = () => {
  return (
    <div>
      <Navbar/>
      <Banner_News_Updates Bannerdata={Bannerdata}/>
      <Slider_Card sliderData={LatestUpdate}/> 

      {/* Vastu Tips */}
      <Slider_Card sliderData={VastuTips}/> 

      {/* DIY  */}
      <Slider_Card sliderData={DIY}/> 
      <Main_Footer/>
    </div>
  )
}

export default NewsUpdates